import { get, isFunction } from "lodash-es";
import { tryEval } from '@tencent/ui-core/lib/utils';
import { getRequestMsg, getResponseMsg } from "./frontEndHttpLog";
import { getHostByUrl } from "../../../tools/url";
export const frontEndHttpHookMiddleware = async (ctx, next) => {
  if (ctx.collection.type !== 'frontEndHttp') {
    await next();
    return;
  }
  const cgiInfo = get(ctx, 'cgiInfo');
  let {
    beforeHooks = [],
    afterHooks = []
  } = cgiInfo;
  [beforeHooks, afterHooks] = [beforeHooks, afterHooks].map(item => item.filter(item => item.enabled));
  if (beforeHooks.length + afterHooks.length <= 0) {
    await next();
    return;
  }
  const beforeContext = {
    options: ctx.request,
    requestConfig: ctx.requestConfig
  };
  for (const before of beforeHooks) {
    const func = beforeProxy.getFunc(before.script);
    if (isFunction(func)) {
      var _ctx$loggerForFrontEn;
      await func(beforeContext);
      (_ctx$loggerForFrontEn = ctx.loggerForFrontEndHttp) === null || _ctx$loggerForFrontEn === void 0 ? void 0 : _ctx$loggerForFrontEn.append({
        dimen4: 'beforeHook',
        dimen5: 'config',
        host: getHostByUrl(ctx.requestConfig.url),
        url: ctx.requestConfig.url,
        level: 1,
        msg: getRequestMsg(ctx.requestConfig)
      });
    }
  }
  await next();
  const afterContext = {
    response: ctx.response
  };
  for (const after of afterHooks) {
    const func = afterProxy.getFunc(after.script);
    if (isFunction(func)) {
      var _ctx$loggerForFrontEn2;
      await func(afterContext);
      (_ctx$loggerForFrontEn2 = ctx.loggerForFrontEndHttp) === null || _ctx$loggerForFrontEn2 === void 0 ? void 0 : _ctx$loggerForFrontEn2.append({
        dimen4: 'afterHook',
        dimen5: 'result',
        host: getHostByUrl(ctx.requestConfig.url),
        url: ctx.requestConfig.url,
        level: 1,
        msg: getResponseMsg(ctx.response)
      });
    }
  }
};
class FuncProxy {
  constructor() {
    this.map = new Map(); // 数据不多，后面再接lru
  }

  getFunc(script) {
    if (!this.map.has(script)) {
      const func = this.getFuncByScript(script);
      this.map.set(script, func);
    }
    return this.map.get(script);
  }
  clear() {
    this.map.clear();
  }
  getFuncByScript(script) {
    const func = tryEval(script);
    return func;
  }
}
const beforeProxy = new FuncProxy();
const afterProxy = new FuncProxy();
//# sourceMappingURL=frontEndHttpHook.js.map
